module.exports = __webpack_public_path__ + "static/media/Elsa.802f61fe.wav";